<template>
  <f7-page>
    <f7-navbar :title="$t('title.topUpCard')" :back-link="$t('action.back')"></f7-navbar>
    <f7-list form>
      <f7-list-input :label="$t('label.amount')" :input="false">
        <div class="item-input-wrap" slot="input">
          <money v-model="amount" v-bind="money" maxlength="9"></money>
        </div>
      </f7-list-input>
      <f7-list-input :label="$tc('label.user', 1)"
                     type="select"
                     :value="userId"
                     @input="userId = $event.target.value"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseUser')}}</option>
        <option v-for="user in myTeamWithCards" :key="user.id" :value="user.id">{{user | name}}</option>
      </f7-list-input>
      <f7-list-input :label="`${$t('label.from')} ${$tc('label.budget', 1)}`"
                     type="select"
                     :value="budgetId"
                     @input="budgetId = $event.target.value"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseBudget')}}</option>
        <option v-for="budget in activeManagedBudgets"
                :key="budget.potId"
                :value="budget.potId"
        >
          {{budget.name}}
        </option>
      </f7-list-input>
      <f7-block>
        <button type="submit" class="button button-big button-fill" @click.prevent="topUp">{{$t('action.topUpCard')}}
        </button>
      </f7-block>
    </f7-list>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'card-topup',
    computed: {
      budget () {
        return this.activeBudgets.find(b => b.potId === parseInt(this.budgetId))
      },
      user () {
        return this.myTeamWithCards.find(u => u.id === parseInt(this.userId))
      },
    },
    async created () {
      this.$store.dispatch('fetchTeam')
      this.$store.dispatch('budgets/fetch')
    },
    updated () {
      const initialBudgetId = parseInt(this.$f7route.params.budget_id)
      if (this.activeBudgets.find(b => b.potId === initialBudgetId) && this.budgetId === 0) this.budgetId = initialBudgetId
      const initialUserId = parseInt(this.$f7route.params.user_id)
      if (this.myTeamWithCards.find(u => u.id === initialUserId) && this.userId === 0) this.userId = initialUserId
    },
    data () {
      return {
        amount: 0,
        budgetId: 0,
        userId: 0,
      }
    },
    filters: {
      name: function (user) {
        return user.firstName + ' ' + user.lastName
      },
    },
    methods: {
      async topUp () {
        const errors = []
        if (this.amount <= 0) errors.push(this.$t('validation.amount'))
        if (this.userId === 0) errors.push(this.$t('validation.chooseUser'))
        if (this.budgetId === 0) errors.push(this.$t('validation.chooseBudget'))
        if (errors.length > 0) this.$f7.dialog.alert(errors.join('<br>'), '')
        else {
          const settings = {
            reason: 'Direct card top up.', //TODO: i18n
            amount: this.amount,
            potId: parseInt(this.budgetId),
            currency: this.budget.currency,
          }
          try {
            await api.postCardTopUp(this.userId, settings)
            this.$f7.dialog.alert(this.$t('dialog.cardTopup', {
              user: `${this.user.firstName} ${this.user.lastName}`,
              amount: this.formatMoney(this.budget.currency, this.amount),
              budget: this.budget.name,
            }), '', () => {
              this.$store.dispatch('budgets/fetch')
              this.goBack()
            })
          } catch (error) {
            //TODO: i18n error message
            this.$f7.dialog.alert(error.response.data, '')
          }
        }
      },
    },
    mixins: [helpers],
    watch: {
      async userId () {
        const card = await api.getCard(this.userId)
        if (card.status === 'Suspended')
          this.$f7.dialog.alert(`${this.user.firstName}'s card is currently frozen. Please be aware that they won't be able to make any purchases with it.`, '')
      },
    },
  }
</script>

<style scoped>

</style>
